'use es6';

import { Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import identity from 'transmute/identity';
import map from 'transmute/map';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EntityType = {
  USER: 'USER',
  TEAM: 'TEAM'
};
const EntityTagGroup = ({
  userValues = ImmutableSet(),
  teamValues = ImmutableSet,
  onCloseClick = identity
}) => {
  const handleClose = (value, type) => () => {
    onCloseClick({
      value,
      type
    });
  };
  return /*#__PURE__*/_jsxs(ExpandableText, {
    children: [map(({
      value,
      name
    }) => /*#__PURE__*/_jsx(Tag, {
      use: "oz",
      closeable: true,
      onCloseClick: handleClose(value, EntityType.TEAM),
      children: name
    }, value), teamValues), map(({
      value,
      name
    }) => /*#__PURE__*/_jsx(Tag, {
      closeable: true,
      onCloseClick: handleClose(value, EntityType.USER),
      children: name
    }, value), userValues)]
  });
};
const ValuePropType = ImmutablePropTypes.setOf(PropTypes.shape({
  value: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}).isRequired);
EntityTagGroup.propTypes = {
  userValues: ValuePropType,
  teamValues: ValuePropType,
  onCloseClick: PropTypes.func
};
export default EntityTagGroup;